import { DataGridPro, jaJP, type DataGridProProps } from "@mui/x-data-grid-pro";
import { type SxProps, type Theme } from "@mui/material";

import { getStickyHeaderSx } from "./DataGrid";

// 不要であったり、不変にしたり等で外から受け取らないプロパティ
type OmitProperties = "density" | "localeText";

interface IProps extends Omit<DataGridProProps, OmitProperties> {
  stickyHeader?: boolean;
}

const CustomerManagementListDataGrid: React.FC<IProps> = ({
  stickyHeader = false,
  ...props
}) => {
  return (
    <DataGridPro
      density="standard"
      localeText={{
        ...jaJP.components.MuiDataGrid.defaultProps.localeText,
      }}
      loading={props.loading ?? false}
      disableSelectionOnClick={props.disableSelectionOnClick ?? false}
      pagination
      {...props}
      sx={[getStickyHeaderSx(stickyHeader), props.sx ?? {}] as SxProps<Theme>}
    />
  );
};

export { CustomerManagementListDataGrid };
